module.exports = __webpack_public_path__ + "static/IMG-20200725-WA0008-eafaebdd9c5432ce6987cf3674a43368.jpg";